import axios from "axios";
import { SERVERPATH } from "./index";
import { getConfig } from "./config";
import { getConfigCached } from "../helpers/config";

const ProductPath = `${SERVERPATH}/products`;
const ProductApplicationPath = `${SERVERPATH}/application-forms/products`;

export async function getPrequalProducts() {
    return await getConfig("prequal_products");
}

export async function getProductsConfig() {
    return await getConfig("product_page");
}

export async function getLoanTypeConfig() {
    return await getConfig("loan_type");
}

export async function getRequirementsURL() {
    return await getConfig("requirements_url");
}

export async function getLoanEndorsementConfig() {
    return await getConfig("loan_endorsement");
}

export async function getProductCardsConfig() {
    return await getConfigCached("product_cards");
}

export async function getLoanTypeConfigCached() {
    return await getConfigCached("loan_type");
}

export async function getProducts(filter = {}) {
    const {
        page = 1,
        limit = 50,
        amount = null,
        term = null,
        category = null,
        top_org: topOrg = null,
        location = null,
        interest = null,
        sort_by: sortBy = null,
        order_by: orderBy = null,
        utm_source: utmSource = null,
        utm_medium: utmMedium = null,
        utm_campaign: utmCampaign = null,
        utm_term: utmTerm = null,
        utm_content: utmContent = null,
        special_product: specialProductCode = null,
        income = null,
        loan_type: loanType = null,
        loan_secured_type: loanSecuredType = null,
        // initial_load = false,
    } = filter;

    const response = await axios.get(`${ProductPath}/`, {
        params: {
            page,
            limit,
            amount,
            term,
            category,
            "top_org": topOrg,
            location,
            interest,
            "income_per_month": income,
            "order_by": orderBy,
            "sort_by": sortBy,
            "special_product_code": specialProductCode,
            "utm_source": utmSource,
            "utm_medium": utmMedium,
            "utm_campaign": utmCampaign,
            "utm_term": utmTerm,
            "utm_content": utmContent,
            "loan_type": loanType,
            "loan_secured_type": loanSecuredType,
        },
    });

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}

export async function getProductById(id) {
    const response = await axios.get(`${ProductPath}/${id}/`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}

export async function getProductApplicationForm(id) {
    const response = await axios.get(`${ProductApplicationPath}/${id}/`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}
